import { useEffect } from "react";
import { useParams } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Open-redirect mode: bounce straight to the server-side 301 endpoint.
// The redirect happens via an HTTP Location header (not client-side JS),
// so any stored scheme is handled by the browser safely.
export default function RedirectPage() {
  const params = useParams();
  const code = params["*"]; // supports multi-segment custom paths

  useEffect(() => {
    document.title = "Redirecting recipient";
    const ref = encodeURIComponent(document.referrer || "");
    window.location.replace(`${BACKEND}/api/r/${code}?ref=${ref}`);
  }, [code]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center mono text-sm text-zinc-500">
      One moment<span className="cursor-blink">…</span>
    </div>
  );
}
